import { useState, useEffect, useRef, forwardRef, useImperativeHandle } from "react";
import { Form } from "react-bootstrap";
import { reducerActions } from "../../../Reducers/FormReducer";

const TextAreaBase = forwardRef((props, ref) => {
  const inputRef = useRef();

  const {
    field,
    objectkey,   
    error,
    touched,
    dispatchState
  } = props;

  const handleChange = (event) => {
    dispatchState({ 
      type: reducerActions.ON_CHANGE_TEXTAREA, 
      payload: { 
        key:objectkey,
        value: event.target.value 
      } 
    });
    
     //grow when multilines are detected
     if (inputRef.current) {
      inputRef.current.setCustomValidity("");
      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  };

    const handleBlur = () => {
      dispatchState({
        type: reducerActions.ON_BLUR_TEXTAREA,
          payload: { 
            key:objectkey       
          } 
      });      
    };


  // Auto-resize on value change
  useEffect(() => {
    if (inputRef.current) {
      inputRef.current.style.height = "auto";
      inputRef.current.style.height = `${inputRef.current.scrollHeight}px`;
    }
  }, [field.value]);

  return (
    <>
     <label htmlFor={props.field.fieldId}
          key={props.objectkey} 
          dangerouslySetInnerHTML = {{ __html: props.field.fieldLabel || props.field.fieldName}}>                
      </label>
      {field.fieldRequired && <span className="text-danger">*</span>}
      &nbsp;
      <span className="input-wrapper">
        <Form.Control
          as="textarea"
          ref={inputRef}
          rows="1"
          id={field.fieldId}
          value={field.fieldValue || ""}
          onChange={handleChange}
          onBlur={handleBlur}
          required={field.fieldRequired}
          maxLength={
            field.maxLength && field.maxLength > 0
              ? field.maxLength
              : "999"
          }
          isInvalid={field.isTouched && !field.isValid}
        />
        <Form.Control.Feedback type="invalid">
          {field.error}
        </Form.Control.Feedback>
      </span>
    </>
  );
});

export default TextAreaBase;